import React, { useContext } from 'react'
import DefaultLayout from '../components/layout/DefaultLayout'
import Hero from '../components/sections/Hero'
import OverviewSection from '../components/sections/OverviewSection'
import ContributeSection from '../components/sections/ContributeSection'
import FaqSection from '../components/sections/FaqSection'
import ResultSection from '../components/sections/ResultSection'
import { rootContexts } from '../contexts/rootContexts'

export default function Overview() {
  const {audioResult}= useContext(rootContexts)

  return (
    <>
      {/* <Translation>
      {(t) => (
        <>
          <div className="flex md:order-2 items-center gap-x-5 md:gap-x-16">
          {t('language')} 
           
          </div>
        </>
      )}
    </Translation> */}
  
    <DefaultLayout >
       
         <Hero />
         <OverviewSection />

         {audioResult ?
         <ResultSection />
         :  <span id="result"></span> }
        
         <ContributeSection />
         <FaqSection />
       

    </DefaultLayout>
    </>
  )
}
